'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _appToolbar = require('./app-toolbar.component');

var _appToolbar2 = _interopRequireDefault(_appToolbar);

require('./app-toolbar.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.app-toolbar', []).component('appToolbar', _appToolbar2.default).name;


// WEBPACK FOOTER //
// ./components/app/common/app-toolbar/app-toolbar.module.js